import {createSlice} from '@reduxjs/toolkit';
import {getProposal} from '../reduxApi/proposalReduxApi.js';

const ProposalSlice = createSlice({  
    name: 'proposal',
    initialState: {
        proposals: [],
    },
    reducers: {},
    extraReducers: (builder)=>{
            builder.addCase(getProposal.fulfilled, (state, action) => {
                console.log("text 34",action.payload);
                state.proposals = action.payload.data.response;
            });
    }},
);
export const { getProposals } = ProposalSlice.actions;    
export default ProposalSlice.reducer;